const pos = [
	{
		icon: "uil-shop",
		title: 'POS',
		show: false,
		children: [
			{
				icon: "uil-shop",
				title: 'POS',
				show: false,
				children: [
					{
						title: true,
						i18n: "POS"
					},
					{
						url: "/dashboard",
						i18n: "Dashboard",
						icon: "uil-dashboard",
						role: "ROLE_OWNER"
						// youtube_url: 'https://youtu.be/RtwCQ1w1Vy8?si=JhfIMIC_VWOF3YUI'
					},
					{
						url: "/documents-in",
						i18n: "GOOD_RECEPTION",
						icon: "uil-bring-front",
						role: "POS_DOCUMENT_IN",
						youtube_url: 'https://youtu.be/RtwCQ1w1Vy8?si=JhfIMIC_VWOF3YUI'
					},
					{
						url: "/didox-invoices",
						i18n: "DIDOX_INCOMING_INVOICES",
						icon: "uil-file-download-alt",
						role: "POS_DOCUMENT_IN",
						flag: "didoxEnabled",
					},
					{
						url: "/sd-purchase",
						i18n: "ORDERS_SD",
						icon: "uil-bring-bottom",
						role: "POS_DOCUMENT_IN"
					},
					{
						url: "/nomenclature",
						i18n: "NOMENCLATURE",
						icon: "uil-list-ul",
						role: "POS_NOMENKLATURA",
						youtube_url: "https://youtu.be/8VN0d68SLfk?si=m11KU5JqvscJ-zXN"
					},
					{
						url: "/revaluation",
						i18n: "REVALUATION",
						icon: "uil-newspaper",
						role: "POS_REVALUATION",
						youtube_url: "https://youtu.be/fBzWn08oCHg?si=_9PV_gyBI-Ca3EjA&t"
					},
					{
						url: "/history",
						i18n: "HISTORY",
						icon: "uil-history",
						role: "POS_HISTORY",
						youtube_url: "https://youtu.be/fBzWn08oCHg?si=_9PV_gyBI-Ca3EjA&t=32"
					},
					{
						url: "/documents-out",
						i18n: "RETURN_TO_SIPPLIER",
						icon: "uil-backspace",
						role: "POS_DOCUMENT_OUT",
						youtube_url: "https://youtu.be/PMeWG4aw3_Q?si=UQ6u6Bn-yTrsJ6QT"
					},
					{
						url: "/write-off",
						i18n: "WRITE_OFF",
						icon: "uil-trash-alt",
						role: "POS_WRITE_OFF",
						youtube_url: "https://youtu.be/8QD91gAzL5s?si=6D4np6ndP8JZzSyN"

					},
					{
						url: "/inventory",
						i18n: "INVENTORY",
						icon: "uil-calculator-alt",
						role: "POS_INVENTORY",
						youtube_url: "https://youtu.be/4vBQCT6g528?si=W3OjEbEvu1fd9GVM"
					},
					{
						url: "/transfer",
						i18n: "DISPLACEMENT",
						icon: "uil-truck",
						role: "POS_TRANSFER",
						youtube_url: 'https://youtu.be/mzp0462WYJ0?si=VfvvOIOvXxWzxzNa&t=1s'
					},
					{
						url: "/orders",
						i18n: "ORDERS",
						icon: "uil-import",
						role: "POS_ORDERS"
					},
					{
						url: "/grouping",
						i18n: "GROUPING",
						icon: "uil-object-ungroup",
						role: "POS_PRODUCT_GROUP",
						youtube_url: "https://youtu.be/R04eqjJbZOk?si=I9Vsdv1E3BcyKPN3"
					},
					{
						url: "/scale",
						i18n: "SCALE",
						icon: "uil-balance-scale",
						role: "POS_SCALE",
						// youtube_url: "https://youtu.be/jsl0j_PN7ck?si=dq9ZNv0li9wCF8Jo"
					},
					{
						url: "/package",
						i18n: "PACKAGES",
						icon: "uil-gift",
						role: "POS_PRODUCT_BOX",
						youtube_url: "https://youtu.be/Bc6pdO8ySVM?si=DBQMnldAYbCEJF5u",
					},
					{
						url: "/promotion",
						i18n: "STOCKS",
						icon: "uil-game-structure",
						role: "POS_PROMOTION",
						youtube_url: "https://youtu.be/s8XgjWec-g0?si=9pok9iigCh6ArKTD",
					},
					{
						url: "/cheques",
						i18n: "CHEQUES",
						icon: "uil-invoice",
						role: "POS_CHEQUE",
						youtube_url: 'https://youtu.be/dqVg-xNn3OQ?si=2w79VpIP7af5pHDA'
					},
					{
						url: "/price-tags",
						i18n: "PRICE_TAGS",
						icon: "uil-pricetag-alt",
						role: "POS_PRICE_TAGS",
						youtube_url: 'https://youtu.be/mDDaB-QDCzY?si=uhpPPAgqwxO1jaPC'
					},
					{
						url: "/notifications",
						i18n: "NOTIFICATIONS",
						icon: "uil-bell",
						role: "POS_NOTIFICATIONS",
						youtube_url: 'https://youtu.be/K6XNHQEUNDY?si=fS_1Yoaurz0-pXd-'
					},
					{
						url: "/financial-operations",
						i18n: "FINANCIAL_OPERATIONS",
						icon: "uil-transaction",
						role: "EXPENSE"
					},
					{
						url: "/trading-point",
						i18n: "TRADING_POINT",
						icon: "uil-store",
						role: "ROLE_OWNER"
					},
					{
						url: "/account-balances",
						i18n: "ACCOUNT_BALANCES",
						icon: "uil-balance-scale",
						role: "ROLE_OWNER"
					},
					// {
					// 	url: "/reports",
					// 	i18n: "REPORTS",
					// 	icon: "uil-chart-pie-alt",
					// 	role: "POS_REPORTS"
					// },
				]
			},
			{
				icon: "uil-graph-bar",
				title: 'REPORTS',
				show: false,
				children: [
					{
						title: true,
						i18n: "REPORTS"
					},
					{
						url: "/report/sales",
						i18n: "SALES_REPORT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_SALES",
						youtube_url: "https://youtu.be/64y24XaG8jo?si=144ZNSG2R_fLOG9F",
					},
					{
						url: "/report/balance",
						i18n: "BALANCE_REPORT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_BALANCE_PRODUCT",
						youtube_url: "https://youtu.be/ioF2DXOo9Cg?si=x7YV8sTHr0j1M-0X",
					},
					{
						url: "/report/incomes",
						i18n: "INCOME_REPORT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_DOCUMENT_IN",
						youtube_url: "https://youtu.be/xGANHXY2Ios?si=Xk-3u5ViGjhGdK6X",
					},
					{
						url: "/report/expenses",
						i18n: "EXPENSE_REPORT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_EXPENSE",
						youtube_url: "https://youtu.be/sfrQV0OVA6I?si=8IZDLvF5sWx8j4M_",
					},
					{
						url: "/report/expiration-date",
						i18n: "EXPIRATION_DATE_REPORT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_EXPDATE",
						youtube_url: "https://youtu.be/zsTPDglbNVs?si=kkifqmhq7DpOuj8n",
					},
					{
						url: "/report/return-products",
						i18n: "RETURN_OF_GOODS",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_RETURNED_ITEMS",
						youtube_url: "https://youtu.be/1YvkhNxuwZM?si=8LMY-PVJTAgMLRgj",
					},
					{
						url: "/report/gross-income",
						i18n: "GROSS_INCOME",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_GROSS_INCOME",
						youtube_url: "https://youtu.be/Ui1bD75c68o?si=SKzyooVmgq2-Ypyu",
					},
					{
						url: "/report/category-managment",
						i18n: "CATEGORY_MANAGEMENT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_MML",
						youtube_url: "https://youtu.be/sjb3kuqqsCo?si=fJ9q84LmyLk21d6Y",
					},
					{
						url: "/report/suppliers",
						i18n: "SUPPLIERS",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_ORGANIZATION",
						youtube_url: "https://youtu.be/W_XrZyt6h20?si=YvvwO-Gjm0_Ip-e7",
					},
					{
						url: "/report/clients",
						i18n: "CLIENTS",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_CLIENTS",
						youtube_url: "https://youtu.be/E3uyx8xuYd8?si=D9IYhtZJVunwystV",
					},
					{
						url: "/report/summary-kpi",
						i18n: "SUMMARY_REPORT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_SUM1",
						youtube_url: "https://youtu.be/aQrnCryKXLU?si=OdI48H9nLkc2e67b",
					},
					{
						url: "/report/summary",
						i18n: "SUMMARY_REPORT_2",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_SUM2",
						youtube_url: "https://youtu.be/BbwfVkVqJ_c?si=AX1wF_DkcHMAp2rd",
					},
					// {
					// 	url: "/report/total",
					// 	i18n: "TOTAL_REPORT",
					// 	icon: "uil-chart-pie-alt",
					// 	role: "POS_REPORTS"
					// },
					{
						url: "/report/write-off",
						i18n: "WRITE_OFF_REPORT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_WRITE_OFF",
						youtube_url: 'https://youtu.be/DNUAjgBJOK4?si=A8DpVGJ9eM3rtYgM'
					},
					{
						url: "/report/cashiers",
						i18n: "CASHIERS_REPORT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_CASHIER",
						youtube_url: 'https://youtu.be/q8GCn2D93KE?si=QS7mxZiWORgtUR-M'
					},
					{
						url: "/report/bonuses",
						i18n: "BONUSES_REPORT",
						icon: "uil-chart-pie-alt",
						role: "POS_REPORT_CASHIER",
						// youtube_url: 'https://youtu.be/q8GCn2D93KE?si=QS7mxZiWORgtUR-M'
					},
				]
			},
			{
				icon: "uil-chart-line",
				title: 'ANALYTICS',
				show: false,
				role: "SETTINGS",
				children: [
					{
						title: true,
						i18n: "ANALYTICS"
					},
					{
						url: "/report/recommended-orders",
						i18n: "RECOMMENDED_ORDERS",
						icon: "uil-tag-alt",
						role: "POS_REPORT_RECOMMENDED",
						youtube_url: "https://youtu.be/B3Attt8A92o?si=llp-8ONGIox98YXS",
					},
					{
						url: "/report/frozen-funds",
						i18n: "FROZEN_FUNDS",
						icon: "uil-chart-down",
						role: "POS_REPORT_FROZEN",
						youtube_url: "https://youtu.be/FBksecB-Kck?si=BqjzfKzhltkM_k5d",
					},
					{
						url: "/report/oos",
						i18n: "OOS",
						icon: "uil-analytics",
						role: "POS_REPORT_OOS",
						youtube_url: "",
					},
					{
						url: "/report/abc",
						i18n: "ABC",
						icon: "uil-abacus",
						role: "POS_REPORT_ABC",
						youtube_url: "",
					},
					{
						url: "/report/marginality",
						i18n: "MARGINALITY_CATEGORY",
						icon: "uil-percentage",
						role: "POS_REPORT_MARGINALITY",
						youtube_url: "",
					},

					{
						url: "/report/product-action",
						i18n: "PRODUCT_ACTION",
						icon: "uil-shopping-cart-alt",
						role: "POS_REPORT_PRODUCT_ACTION",
						youtube_url: "",
					},
					{
						url: "/report/product-unsold",
						i18n: "PRODUCT_UNSOLD",
						icon: "uil-shopping-cart-alt",
						role: "POS_REPORT_PRODUCT_ACTION",
						youtube_url: "",
					},
				]
			},
			{
				icon: "uil-cell",
				title: 'SETTINGS',
				show: false,
				role: "POS_SETTINGS",
				children: [
					{
						title: true,
						i18n: "SETTINGS"
					},
					{
						url: "/settings",
						i18n: "SETTINGS",
						icon: "uil-setting",
						role: "POS_SETTINGS",
						youtube_url: "https://youtu.be/WeTjTZlT-2E?si=BIO-633Yr5ni-djo",
					},
					{
						url: "/sms-settings",
						i18n: "SMS_SETTINGS",
						icon: "uil-comment-alt-message",
						role: "POS_SETTINGS",
					},
					{
						url: "/pos",
						i18n: "POSES",
						icon: "uil-shop",
						role: "POS_SETTINGS_POS",
						youtube_url: "https://youtu.be/uZFqPDiH4ro?si=KoIpLIxEqFBN95yq",
					},
					{
						url: "/cashbox",
						i18n: "POSES_CASHIER",
						icon: "uil-money-withdrawal",
						role: "POS_SETTINGS_POS_CASHBOX",
						youtube_url: "https://youtu.be/MixjbkOvwa8?si=ZgGVBPMmrXys1ihK",
					},
					{
						title: true,
						i18n: "GENERAL"
					},
					{
						url: "/workers",
						i18n: "MY_USERS",
						icon: "uil-user-square",
						role: "MAIN_USERS",
						youtube_url: "https://youtu.be/REeOm7kByl8?si=Twad-PqWjM8_mIyh",
					},
					{
						url: "/products",
						i18n: "PRODUCTS",
						icon: "uil-shopping-cart",
						role: "MAIN_PRODUCTS",
						youtube_url: "https://youtu.be/3dkaGaiEjNI?si=kPsdPTR9kL6oG2C_",
					},
					{
						url: "/dealer",
						i18n: "DEALER",
						icon: "uil-shopping-cart",
						role: "MAIN_PRODUCTS",
						youtube_url: "https://youtu.be/ekAKR8EmYbw?si=m1f-bOiXDAIijrbj",
					},
					{
						url: "/loyalty",
						i18n: "LOYALTY_MENU",
						icon: "uil-gift",
						role: "MAIN_PRODUCTS",
						// youtube_url: "",
					},
					{
						url: "/product-categories",
						i18n: "ADDITIONAL_PRODUCT_CATEGORIES",
						icon: "uil-shopping-cart",
						role: "MAIN_PRODUCTS",
						youtube_url: "https://youtu.be/aa8XSHxAfoA?si=D_5tfgyph1FxutXs",
					},
					{
						url: "/suppliers",
						i18n: "SUPPLIERS",
						icon: "uil-truck-loading",
						role: "MAIN_ORGANIZATION",
						youtube_url: "https://youtu.be/W_XrZyt6h20?si=fM7kF21y6b_6S_Pd",
					},
					{
						url: "/clients",
						i18n: "CLIENTS",
						icon: "uil-users-alt",
						role: "MAIN_CLIENTS",
						youtube_url: "https://youtu.be/KhAdrGgTRVo?si=LGZIZzFGIMWQxYKu",
					},
					{
						url: "/currency",
						i18n: "CURRENCY",
						icon: "uil-money-bill",
						role: "MAIN_CURRENCY",
						youtube_url: "https://youtu.be/q-nAyk_DbHE?si=NsCVK3y33jC7_jy7",
					},
					{
						url: "/expense",
						i18n: "EXPENSES",
						icon: "uil-money-insert",
						role: "MAIN_EXPENSE",
						youtube_url: "https://youtu.be/YpX8WrsmOX8?si=8wVvpTj7Wka6cKuA",
					},
				]
			},

		]
	}
]

export default pos
